import _ from 'lodash';
import { QueryString } from '~/utils';
import { get, post, patch, del } from './agent';

const projectTaskTemplates =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'project-task-templates', id]).compact().join('/');

    return {
      get: (query = {}, config) => get(url.concat(new QueryString(query).toString(true)), config),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: () => del(url),
    };
  };

export default projectTaskTemplates;
